import styled from "@emotion/styled"
import { Typography } from "@mui/material"

export const StatisticsDescription = styled(Typography)`
  font-weight: 600;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-size: 1.0625rem;
    line-height: 1.75rem;
  }
`

export const ValueContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 2.5rem;
  line-height: 3rem; /* 120% */
  letter-spacing: 0.025rem;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-size: 4rem;
    line-height: 5rem; /* 125% */
    letter-spacing: 0.04rem;
  }
`
export const StatisticsNumber = styled(Typography)`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 2.5rem;
  line-height: 3rem; /* 120% */
  letter-spacing: 0.025rem;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-size: 4rem;
    line-height: 5rem; /* 125% */
    letter-spacing: 0.04rem;
  }
`

export const StatisticsItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1.5rem;
  width: 100%;
  padding-top: 0.5rem;
  border-top: 1px solid #000;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-top: 0;
    border-top: none;
  }
`
